import { ReportType } from '@cambridgeassessment/lib-ee-commons';
import { currentTime } from './time';
import { SearchQuery } from '../types/Plagiarism';

export const DOWNLOAD_DELAY_IN_MS = 800;

export const buildReportName = (reportType: string, series?: string, query?: SearchQuery): string => {
  let reportString;
  switch (reportType) {
    case ReportType.SUBMITTED_EXAMINED:
      reportString = 'ExaminedCentresSubmissions';
      break;
    case ReportType.NOT_SUBMITTED_EXAMINED:
      reportString = 'ExaminedCentresToChase';
      break;
    case ReportType.SUBMITTED_MODERATED:
      reportString = 'ModeratedCentresSubmissions';
      break;
    case ReportType.NOT_SUBMITTED_MODERATED:
      reportString = 'ModeratedCentresToChase';
      break;
    case ReportType.COMPONENT_BUSINESS_RULES:
      reportString = 'SubmitForAssessment_CompRules';
      break;
    case ReportType.TRAINING:
      reportString = 'CanUseAsTrainingMaterial';
      break;
    case ReportType.PLAGIARISM_ALL_CANDIDATES:
      reportString = 'SimilarityIndexFullCand';
      break;
    case ReportType.PLAGIARISM_BY_QUERY:
      reportString = 'SimilarityIndexSummary';
      break;
    case ReportType.PLAGIARISM_ERRORS:
      reportString = 'SimilarityIndexAllErrors';
  }

  const queryValues = query
    ? Object.entries(query).reduce((acc, [key, value]) => {
        const queryValue = value && key !== 'seriesId' ? `_${value}` : '';
        return `${acc}${queryValue}`;
      }, '')
    : '';

  const componentRulesReportTitle = `${reportString}_${currentTime().format('DD_MM_YYYY')}.xlsx`;
  const nonComponentRulesReportTitle = `${series?.replace(
    ' ',
    '',
  )}${queryValues}_${reportString}_${currentTime().format('DD_MM_YYYY')}.csv`;

  return reportType === ReportType.COMPONENT_BUSINESS_RULES ? componentRulesReportTitle : nonComponentRulesReportTitle;
};

export const downloadHandler = (data: Blob, filename: string): void => {
  const url = window.URL.createObjectURL(data);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const downloadFromBlob = (data: Blob, name?: string, target = '_blank'): void => {
  const url = window.URL.createObjectURL(data);
  const link = document.createElement('a');
  link.href = url;
  link.target = target;
  link.setAttribute('download', name ?? '');
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const downloadFromUrl = (url: string, name?: string, target = '_blank'): void => {
  const link = document.createElement('a');
  link.href = url;
  link.target = target;
  link.setAttribute('download', name ?? '');
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
